// extracted by mini-css-extract-plugin
export default {"headingWrapper":"heading_headingWrapper__2Uea1","extraspace":"heading_extraspace__b9NyA","iconHeader":"heading_iconHeader__l8K9a"};